import { useState } from 'react';
import JWButton from '../brand/JWButton';
import JWModal from '../brand/JWModal';
import './paymentModal.css';
import StarIcon from '../../assets/icons/StarIcon';
import FlameIcon from '../../assets/icons/FlameIcon';

interface PaymentTypeModalProps {
    show: boolean,
    setShow: (show: boolean) => void,
    onPaymentSelect: (paymentType: string) => void,
    onClose: () => void,
}

const PaymentTypeModal = ({ show, setShow, onPaymentSelect, onClose }: PaymentTypeModalProps) => {
    const modalBody = (
        <div className="flex flex-col w-full">
            <div className="m-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* One-time payment option */}
                    <button
                        className="payment-tile p-4 rounded-lg transition-colors flex flex-col items-center justify-center border-2 bg-white text-gray-800 border-gray-300 hover:border-purple-500 hover:bg-purple-50"
                        onClick={() => onPaymentSelect('payment')}
                    >
                        <div className="w-12 h-12 flex items-center justify-center mb-2 rounded-full bg-opacity-20 bg-black bg-circle-animate icon-pulse">
                            <div className="star-animate">
                                <StarIcon stroke="#FFD700" />
                            </div>
                        </div>
                        <span className="font-medium">One-Time Boost</span>
                        <span className="text-2xl font-bold mt-2">$2.99</span>
                        <span className="text-xs mt-1 text-center">Single boost for better placement (7 days)</span>
                    </button>

                    {/* Subscription option */}
                    <button
                        className="payment-tile p-4 rounded-lg transition-colors flex flex-col items-center justify-center border-2 bg-white text-gray-800 border-gray-300 hover:border-purple-500 hover:bg-purple-50"
                        onClick={() => onPaymentSelect('subscription')}
                    >
                        <div className="w-12 h-12 flex items-center justify-center mb-2 rounded-full bg-opacity-20 bg-black bg-circle-animate icon-pulse">
                            <div className="flame-animate">
                                <FlameIcon stroke="#EF4060" />
                            </div>
                        </div>
                        <span className="font-medium">Monthly Boost</span>
                        <span className="text-2xl font-bold mt-2">$9.99<span className="text-sm font-normal">/month</span></span>
                        <span className="text-xs mt-1 text-center">Continuous boost for better placement and premium features</span>
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <JWModal
            title={'Boost Your Profile'}
            show={show}
            onClose={onClose}
            setShow={setShow}
            wrapperClassName={'md:w-[600px] w-full h-auto overflow-hidden'}
        >
            {modalBody}
        </JWModal>
    );
};

export default PaymentTypeModal;
